import React, { useState, useEffect } from "react";
import { getProducts } from "../../api/calls/product/products";
import { IconButtonControl, LabelControl, ProductsBigControl, ScreenContainerControl } from "doshx_controls_web";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedProduct } from "../../reducers/slices/selection";
import { faFlame } from "@fortawesome/pro-solid-svg-icons";
import { generateDiscountLabel } from "../../helpers/calculateDiscountPercentage";
export const HotDealsPage = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [onPromotionProducts, setOnPromotionProducts] = useState([]);
    const [onPromotionTotalRecords, setOnPromotionTotalRecords] = useState("0");
    const [onPromotionCurrentPage, setOnPromotionCurrentPage] = useState(1);
    const [onPromotionRecordsPerPage, setOnPromotionRecordsPerPage] = useState(20);
    useEffect(() => {
        getProducts({
            page: onPromotionCurrentPage.toString(),
            size: onPromotionRecordsPerPage.toString(),
            on_promotion: true,
        }).then((response) => {
            // console.log("hot-deals-products response", response);
            setOnPromotionProducts(response.content.product_list);
            setOnPromotionTotalRecords(response.content.count);
        });
    }, [onPromotionCurrentPage]);
    useEffect(() => {
        //
    }, []);
    return (React.createElement("div", { className: "" },
        React.createElement(ScreenContainerControl, { className: "flex flex-col gap-8" },
            React.createElement("div", { className: "flex items-center p-0" },
                React.createElement(IconButtonControl, { icon: faFlame, iconColor: "text-primary" //
                    , size: "large", backgroundColor: "bg-transparent", borderColor: "border-borders-light" }),
                React.createElement(LabelControl, { label: "Hot Sale!", textColor: "text-borders-dark", bold: true, size: "xlarge" //
                 })),
            onPromotionProducts && onPromotionProducts.length > 0 && (React.createElement(ProductsBigControl, { colors: {
                    discount: {
                        textColor: `text-shadows-light`,
                        // iconColor: `text-primary`,
                        amountColor: `text-borders-dark`,
                        backgroundColor: `bg-primary`,
                    },
                }, button: {
                    backgroundColor: `bg-primary`,
                    label: `Add to cart`,
                    textColor: `text-secondary`,
                    borderColor: `border-borders-dark`,
                    onClick(product) {
                        // console.log("product", product);
                        dispatch(setSelectedProduct(product));
                        navigate(`/product/${product._id}`);
                    },
                }, products: onPromotionProducts.map((product, index) => {
                    return {
                        index: index,
                        _id: product._id,
                        image: product.image_url,
                        title: product.title,
                        amount: product.price,
                        // rating: product.rating.average,
                        borderColor: "border-borders-light",
                        shadowColor: "shadow-shadows-dark/5",
                        textColor: `text-primary`,
                        amountColor: product.on_promotion ? `text-disabled` : `text-primary`,
                        starActiveColor: `text-borders-light`,
                        starInactiveColor: `text-borders-light`,
                        loaderColor: `text-primary`,
                        backgroundColor: `bg-secondary`,
                        discountLabel: generateDiscountLabel(product.on_promotion, product.price, product.promotion_price),
                        discountAmount: product.on_promotion ? product.promotion_price : "",
                    };
                }), onClick: (product) => {
                    // console.log("product", product);
                    dispatch(setSelectedProduct(product));
                    navigate(`/product/${product._id}`);
                }, pagination: {
                    currentPage: onPromotionCurrentPage,
                    totalRecords: parseInt(onPromotionTotalRecords),
                    recordsPerPage: onPromotionRecordsPerPage,
                    onClick: (pageNumber) => {
                        setOnPromotionCurrentPage(pageNumber);
                    },
                    colors: {
                        selected: {
                            backgroundColor: `bg-primary`,
                            textColor: `text-secondary`,
                            borderColor: `border-borders-light`,
                        },
                        unselected: {
                            backgroundColor: `bg-primary`,
                            textColor: `text-secondary`,
                            borderColor: `border-borders-light`,
                        },
                    },
                } })))));
};
